import requestProvider from "./axiosHandler";

const getAllProductionProcess = () => {
    return requestProvider
        .get('/production-process/get-all')
};

const createProductionProcess = (list) => {
    return requestProvider
        .post('/production-process',list )
};

const updateProductionProcess = () => {
    return requestProvider
        .put('production-process')
};

const deleteProductionProcess = (id) => {
    return requestProvider
        .delete(`/production-process/${id}`)
};

const getProductionProcessById = (id) => {
    return requestProvider
        .get(`/production-process/${id}`)
};

const getProductionProcessWithPage = (page = 0, pageSize = 10) => {
    return requestProvider
        .get(`/production-process?field=createdDate&order=desc&page=${page}&per_page=${pageSize}`)
};

export {getAllProductionProcess, createProductionProcess, updateProductionProcess, deleteProductionProcess, getProductionProcessById, getProductionProcessWithPage}